import clsx from 'clsx';
import { useCallback } from 'react';
import { ComponentSize } from '../../../types';
import { CHECKBOX_ICON_SIZE } from './Checkbox.constants';
import { CheckboxProps } from './Checkbox.types';

const Checkbox = ({ checked, setChecked, disabled, size = ComponentSize.SMALL, error }: CheckboxProps) => {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (disabled) return;
      e.stopPropagation();
      setChecked(!checked);
    },
    [checked, disabled, setChecked]
  );

  const iconSize = typeof size === 'number' ? size : CHECKBOX_ICON_SIZE[size];

  return (
    <div
      className={clsx(
        'flex items-center justify-center rounded-sm border transition-all duration-200',
        error ? 'border-error bg-error-content' : 'border-neutral bg-neutral-content',
        disabled ? 'cursor-not-allowed opacity-40' : 'cursor-pointer'
      )}
      style={{ width: iconSize, height: iconSize }}
      onClick={handleClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={iconSize}
        height={iconSize}
        viewBox="0 0 13 12"
        fill="none"
        className={clsx('transition-all duration-200', checked ? 'scale-100 opacity-100' : 'scale-0 opacity-0')}
      >
        <path
          d="M10.5 2.75L5 8.25L2.5 5.75"
          stroke={error ? '#C02B2B' : '#5B5E5D'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default Checkbox;
